var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7809 6.60015C21.7809 6.60015 21.566 5.08335 20.9043 4.41733C20.0664 3.54077 19.1297 3.53647 18.7 3.48491C15.6234 3.26147 11.0043 3.26147 11.0043 3.26147H10.9957C10.9957 3.26147 6.37656 3.26147 3.3 3.48491C2.87031 3.53647 1.93359 3.54077 1.0957 4.41733C0.433984 5.08335 0.223437 6.60015 0.223437 6.60015C0.223437 6.60015 0 8.38335 0 10.1623V11.8294C0 13.6083 0.219141 15.3916 0.219141 15.3916C0.219141 15.3916 0.433984 16.9083 1.09141 17.5744C1.9293 18.4509 3.0293 18.4208 3.51914 18.5154C5.28086 18.683 11 18.7345 11 18.7345C11 18.7345 15.6234 18.7259 18.7 18.5068C19.1297 18.4552 20.0664 18.4509 20.9043 17.5744C21.566 16.9083 21.7809 15.3916 21.7809 15.3916C21.7809 15.3916 22 13.6126 22 11.8294V10.1623C22 8.38335 21.7809 6.60015 21.7809 6.60015ZM8.72695 13.8533V7.67007L14.6695 10.7724L8.72695 13.8533Z",
    fill: "#0F1111",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.25988f69c4bc869f79cf95fa042d13d1.svg";
export { ForwardRef as ReactComponent };